var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMaterialDelete = function SvgIconMaterialDelete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.425,
    height: 24.975,
    viewBox: "0 0 19.425 24.975",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.888,26.7a2.783,2.783,0,0,0,2.775,2.775h11.1A2.783,2.783,0,0,0,25.538,26.7V10.05H8.888ZM26.925,5.888H22.069L20.681,4.5H13.744L12.356,5.888H7.5V8.663H26.925Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#d85e62"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMaterialDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-material-delete.b6d9a67c8bbcb99e8ddd0fe60eaa8530.svg";